import moment from 'moment-timezone-custom';

import 'moment-timezone';
import { PillTheme } from '@/components/UI/Pill';

export const formatDate = (date: string, format: string) => {
  return moment(date).format(format);
};

export const getLocalDate = (date: string, format: string) => {
  // create a new moment object from the UTC string
  const utcMoment = moment(date);

  // convert the UTC moment object to the user's local time zone
  const localMoment = utcMoment.tz(moment.tz.guess()).toISOString();

  return formatDate(localMoment, format);
};

export enum HumanizedDate {
  TODAY = 'Today',
  TOMORROW = 'Tomorrow',
  NEXT_WEEK = 'NextWeek',
  SAME_ELSE = 'SameElse',
  PAST = 'Past',
}

export const DateThemeMap: Record<
  HumanizedDate,
  {
    theme: PillTheme;
    pulse: boolean;
    dot?: boolean;
  }
> = {
  [HumanizedDate.TODAY]: { theme: PillTheme.RED, pulse: true, dot: true },
  [HumanizedDate.TOMORROW]: { theme: PillTheme.RED, pulse: false, dot: true },
  [HumanizedDate.NEXT_WEEK]: {
    theme: PillTheme.ORANGE,
    pulse: false,
    dot: true,
  },
  [HumanizedDate.SAME_ELSE]: {
    theme: PillTheme.GREEN,
    pulse: false,
    dot: false,
  },
  [HumanizedDate.PAST]: { theme: PillTheme.NEUTRAL, pulse: false, dot: false },
};

const getHumanizedDateEnum = (date: string | number | Date): HumanizedDate => {
  const now = moment();
  const inputDate = moment(date);
  if (inputDate.isSame(now, 'day')) return HumanizedDate.TODAY;
  if (inputDate.isSame(now.clone().add(1, 'day'), 'day'))
    return HumanizedDate.TOMORROW;
  if (
    inputDate.isAfter(now, 'day') &&
    inputDate.isBefore(now.clone().add(7, 'day'), 'day')
  )
    return HumanizedDate.NEXT_WEEK;
  if (inputDate.isBefore(now)) return HumanizedDate.PAST;
  return HumanizedDate.SAME_ELSE;
};

export const humanizeDate = (date: string | number | Date) => {
  return moment(date).calendar(null, {
    sameDay: '[Today] @ hh:mm A',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastWeek: '[Last] dddd',
    sameElse: 'MMM D, YYYY',
  });
};

export const getHumanizedDate = (
  date: string | number | Date
): [string, HumanizedDate] => {
  return [humanizeDate(date), getHumanizedDateEnum(date)];
};
